import React from 'react';
import { V2CommonProvider } from '../state/CommonProvider';
import { V2SessionProvider } from '../state/SessionProvider';

export default function V2Providers({ children, initialSession }) {
  return (
    <V2CommonProvider>
      <V2SessionProvider initialSession={initialSession}>
        {children}
      </V2SessionProvider>
    </V2CommonProvider>
  );
}
